// BIN 数据库 - 银行卡号段识别
// BIN (Bank Identification Number) 是卡号前 6-8 位

export interface BINInfo {
  bin: string;
  bank: string;
  bankEn: string;
  cardType: 'credit' | 'debit' | 'prepaid' | 'unknown';
  cardBrand: string;
  country: string;
  countryCode: string;
}

// 中国主要银行 BIN 数据库
const CHINA_BIN_DATABASE: BINInfo[] = [
  // 工商银行 ICBC
  { bin: '621226', bank: '中国工商银行', bankEn: 'ICBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621227', bank: '中国工商银行', bankEn: 'ICBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621781', bank: '中国工商银行', bankEn: 'ICBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621785', bank: '中国工商银行', bankEn: 'ICBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622200', bank: '中国工商银行', bankEn: 'ICBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622202', bank: '中国工商银行', bankEn: 'ICBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622203', bank: '中国工商银行', bankEn: 'ICBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '955880', bank: '中国工商银行', bankEn: 'ICBC', cardType: 'credit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622230', bank: '中国工商银行', bankEn: 'ICBC', cardType: 'credit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  
  // 建设银行 CCB
  { bin: '621700', bank: '中国建设银行', bankEn: 'CCB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622280', bank: '中国建设银行', bankEn: 'CCB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622700', bank: '中国建设银行', bankEn: 'CCB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '436742', bank: '中国建设银行', bankEn: 'CCB', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
  { bin: '436745', bank: '中国建设银行', bankEn: 'CCB', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
  { bin: '553242', bank: '中国建设银行', bankEn: 'CCB', cardType: 'credit', cardBrand: 'MasterCard', country: '中国', countryCode: 'CN' },
  
  // 农业银行 ABC
  { bin: '622848', bank: '中国农业银行', bankEn: 'ABC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622849', bank: '中国农业银行', bankEn: 'ABC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621282', bank: '中国农业银行', bankEn: 'ABC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621336', bank: '中国农业银行', bankEn: 'ABC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622836', bank: '中国农业银行', bankEn: 'ABC', cardType: 'credit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  
  // 中国银行 BOC
  { bin: '621660', bank: '中国银行', bankEn: 'BOC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621661', bank: '中国银行', bankEn: 'BOC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621662', bank: '中国银行', bankEn: 'BOC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621663', bank: '中国银行', bankEn: 'BOC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622760', bank: '中国银行', bankEn: 'BOC', cardType: 'credit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '625908', bank: '中国银行', bankEn: 'BOC', cardType: 'credit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  
  // 招商银行 CMB
  { bin: '621485', bank: '招商银行', bankEn: 'CMB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621486', bank: '招商银行', bankEn: 'CMB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622580', bank: '招商银行', bankEn: 'CMB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622588', bank: '招商银行', bankEn: 'CMB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '439188', bank: '招商银行', bankEn: 'CMB', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
  { bin: '439227', bank: '招商银行', bankEn: 'CMB', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
  { bin: '518710', bank: '招商银行', bankEn: 'CMB', cardType: 'credit', cardBrand: 'MasterCard', country: '中国', countryCode: 'CN' },

  // 交通银行 BOCOM
  { bin: '621436', bank: '交通银行', bankEn: 'BOCOM', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621335', bank: '交通银行', bankEn: 'BOCOM', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622258', bank: '交通银行', bankEn: 'BOCOM', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '405512', bank: '交通银行', bankEn: 'BOCOM', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
  { bin: '458123', bank: '交通银行', bankEn: 'BOCOM', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
  
  // 邮储银行 PSBC
  { bin: '621096', bank: '中国邮政储蓄银行', bankEn: 'PSBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '621098', bank: '中国邮政储蓄银行', bankEn: 'PSBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622150', bank: '中国邮政储蓄银行', bankEn: 'PSBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622151', bank: '中国邮政储蓄银行', bankEn: 'PSBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  
  // 浦发银行 SPDB
  { bin: '621289', bank: '浦发银行', bankEn: 'SPDB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622516', bank: '浦发银行', bankEn: 'SPDB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622517', bank: '浦发银行', bankEn: 'SPDB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '498451', bank: '浦发银行', bankEn: 'SPDB', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
  
  // 民生银行 CMBC
  { bin: '621691', bank: '民生银行', bankEn: 'CMBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622615', bank: '民生银行', bankEn: 'CMBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622616', bank: '民生银行', bankEn: 'CMBC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '415599', bank: '民生银行', bankEn: 'CMBC', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
  
  // 兴业银行 CIB
  { bin: '621390', bank: '兴业银行', bankEn: 'CIB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622909', bank: '兴业银行', bankEn: 'CIB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622908', bank: '兴业银行', bankEn: 'CIB', cardType: 'credit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  
  // 中信银行 CITIC
  { bin: '621767', bank: '中信银行', bankEn: 'CITIC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622690', bank: '中信银行', bankEn: 'CITIC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622691', bank: '中信银行', bankEn: 'CITIC', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '433670', bank: '中信银行', bankEn: 'CITIC', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
  
  // 光大银行 CEB
  { bin: '621492', bank: '光大银行', bankEn: 'CEB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622660', bank: '光大银行', bankEn: 'CEB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622661', bank: '光大银行', bankEn: 'CEB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '406252', bank: '光大银行', bankEn: 'CEB', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
  
  // 华夏银行 HXB
  { bin: '621222', bank: '华夏银行', bankEn: 'HXB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622630', bank: '华夏银行', bankEn: 'HXB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622631', bank: '华夏银行', bankEn: 'HXB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  
  // 平安银行 PAB
  { bin: '621626', bank: '平安银行', bankEn: 'PAB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622155', bank: '平安银行', bankEn: 'PAB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622156', bank: '平安银行', bankEn: 'PAB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '526855', bank: '平安银行', bankEn: 'PAB', cardType: 'credit', cardBrand: 'MasterCard', country: '中国', countryCode: 'CN' },
  
  // 广发银行 GDB
  { bin: '621462', bank: '广发银行', bankEn: 'GDB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622555', bank: '广发银行', bankEn: 'GDB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '622556', bank: '广发银行', bankEn: 'GDB', cardType: 'debit', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
  { bin: '406365', bank: '广发银行', bankEn: 'GDB', cardType: 'credit', cardBrand: 'Visa', country: '中国', countryCode: 'CN' },
];

// 国际卡组织 BIN 数据库
const INTERNATIONAL_BIN_DATABASE: BINInfo[] = [
  // Visa
  { bin: '4', bank: 'Visa', bankEn: 'Visa', cardType: 'unknown', cardBrand: 'Visa', country: '国际', countryCode: 'INT' },
  
  // MasterCard
  { bin: '51', bank: 'MasterCard', bankEn: 'MasterCard', cardType: 'unknown', cardBrand: 'MasterCard', country: '国际', countryCode: 'INT' },
  { bin: '52', bank: 'MasterCard', bankEn: 'MasterCard', cardType: 'unknown', cardBrand: 'MasterCard', country: '国际', countryCode: 'INT' },
  { bin: '53', bank: 'MasterCard', bankEn: 'MasterCard', cardType: 'unknown', cardBrand: 'MasterCard', country: '国际', countryCode: 'INT' },
  { bin: '54', bank: 'MasterCard', bankEn: 'MasterCard', cardType: 'unknown', cardBrand: 'MasterCard', country: '国际', countryCode: 'INT' },
  { bin: '55', bank: 'MasterCard', bankEn: 'MasterCard', cardType: 'unknown', cardBrand: 'MasterCard', country: '国际', countryCode: 'INT' },
  { bin: '2221', bank: 'MasterCard', bankEn: 'MasterCard', cardType: 'unknown', cardBrand: 'MasterCard', country: '国际', countryCode: 'INT' },
  
  // American Express
  { bin: '34', bank: 'American Express', bankEn: 'American Express', cardType: 'credit', cardBrand: 'AmEx', country: '国际', countryCode: 'INT' },
  { bin: '37', bank: 'American Express', bankEn: 'American Express', cardType: 'credit', cardBrand: 'AmEx', country: '国际', countryCode: 'INT' },
  
  // Discover
  { bin: '6011', bank: 'Discover', bankEn: 'Discover', cardType: 'unknown', cardBrand: 'Discover', country: '美国', countryCode: 'US' },
  { bin: '65', bank: 'Discover', bankEn: 'Discover', cardType: 'unknown', cardBrand: 'Discover', country: '美国', countryCode: 'US' },
  
  // JCB
  { bin: '3528', bank: 'JCB', bankEn: 'JCB', cardType: 'unknown', cardBrand: 'JCB', country: '日本', countryCode: 'JP' },
  { bin: '3529', bank: 'JCB', bankEn: 'JCB', cardType: 'unknown', cardBrand: 'JCB', country: '日本', countryCode: 'JP' },
  
  // Diners Club
  { bin: '300', bank: 'Diners Club', bankEn: 'Diners Club', cardType: 'credit', cardBrand: 'Diners', country: '国际', countryCode: 'INT' },
  { bin: '36', bank: 'Diners Club', bankEn: 'Diners Club', cardType: 'credit', cardBrand: 'Diners', country: '国际', countryCode: 'INT' },
  { bin: '38', bank: 'Diners Club', bankEn: 'Diners Club', cardType: 'credit', cardBrand: 'Diners', country: '国际', countryCode: 'INT' },
  
  // UnionPay 通用
  { bin: '62', bank: '银联卡', bankEn: 'UnionPay', cardType: 'unknown', cardBrand: 'UnionPay', country: '中国', countryCode: 'CN' },
];

// 合并数据库，中国银行优先（更精确）
const BIN_DATABASE = [...CHINA_BIN_DATABASE, ...INTERNATIONAL_BIN_DATABASE];

// 按 BIN 长度降序排序，确保更精确的匹配优先
BIN_DATABASE.sort((a, b) => b.bin.length - a.bin.length);

// 查询 BIN 信息
export const lookupBIN = (cardNumber: string): BINInfo | null => {
  const cleaned = cardNumber.replace(/\D/g, '');
  if (cleaned.length < 6) return null;
  
  for (const info of BIN_DATABASE) {
    if (cleaned.startsWith(info.bin)) {
      return info;
    }
  }
  
  return null;
};

// 获取卡类型中文名
export const getCardTypeName = (cardType: string): string => {
  switch (cardType) {
    case 'credit': return '信用卡';
    case 'debit': return '借记卡';
    case 'prepaid': return '预付卡';
    default: return '未知';
  }
};

// 获取完整的卡信息描述
export const getCardDescription = (cardNumber: string): string => {
  const info = lookupBIN(cardNumber);
  if (!info) return '未知卡类型';
  
  const cardTypeName = getCardTypeName(info.cardType);
  return `${info.bank} ${info.cardBrand} ${cardTypeName}`;
};
